const modalsSelector = (state: any) => ({
  errorModalOpen: state.modalsReducer.error.open as boolean,
  errorModalTitle: state.modalsReducer.error.title as string,
  errorModalMessage: state.modalsReducer.error.message as string,
});

export default modalsSelector;
